"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-right"
  }, [_c("div", {
    staticStyle: {
      height: "100%"
    }
  }, [_c("div", {
    staticClass: "header"
  }, [_c("headr")], 1), _vm._v(" "), true ? _c("div", {
    staticClass: "tab-box"
  }, [_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.menusList, function (item, index) {
    return _c("el-tab-pane", {
      attrs: {
        label: item.name,
        name: "tag" + item.id
      },
      on: {
        key: index
      }
    }, [_vm.activeName == "tag" + item.id && item.name == "数据分析" ? _c("analyse") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "能耗汇总" ? _c("collect") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "历史数据" ? _c("historical") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "能耗查询" ? _c("energy") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "数据统计" ? _c("statistics") : _vm._e()], 1);
  }), 1)], 1) : _vm._e()])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;